import React, { useState, useEffect } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Banner from './Banner';
import Required from './Required';
import Needlessly from './Needlessly';
import Media from './Media';
import FormInfo from './FormInfo';
import FormSubmit from './FormSubmit';
import { submitFormHandleArea2025, getHostHandleArea2025, updateFormHandleArea2025 } from '@src/services/api';
import { Toast, SpinLoading } from 'antd-mobile';
import Confirm from './Confirm';
import Success from './Success';
import { getlocal, setlocal, getStringLenth } from '@src/utils/index';
import SecondShare from './secondShare';
import { area } from '@src/utils/area';

let checkRequiredSucess = false;

const Layout = () => {
    // 提交数据加载态
    const [languages, setLanguages] = useState(() => getlocal('arealanguages') || 'zh');
    // 提交数据加载态
    const [isShowLoading, setIsShowLoading] = useState(false);
    // 是否勾选知晓信息
    const [understand, setUnderstand] = useState(false);
    // 获取更新id
    const [updateId, setUpdateId] = useState(() => getlocal('area_id'));
    const [updateSuccess, setUpdateSuccess] = useState(false);
    // 是否提交
    const [isClickSubmit, setIsClickSubmit] = useState(false);
    // 确认弹窗
    const [confirmData, setConfirmData] = useState({
        isClickOk: false,
        isCheck: false,
        isClosePopup: true,
    });
    // 提交成功弹窗
    const [hasSucessPopup, setHasSucessPopup] = useState(false);
    // 必选项
    const [formData, setFormData] = useState({
        name: '',
        gender: '',
        age: '',
        education_level: '',
        career: '',
        language: '',
        country: '',
        living_city: '',
        documents: '',
        mobile_number: '',
        email: '',
        wechat_id: '',
        social_media_accounts: '',
        major: '',
        work_experience: '',
        self_introduction: '',
        img1: '',
        img2: '',
        img3: '',
        video1: '',
    });
    const [warningTextList, setWarningTextList] = useState({
        name: {
            value: '',
            isScrollTop: false,
        },
        gender: {
            value: '',
            isScrollTop: false,
        },
        age: {
            value: '',
            isScrollTop: false,
        },
        education_level: {
            value: '',
            isScrollTop: false,
        },
        career: {
            value: '',
            isScrollTop: false,
        },
        language: {
            value: '',
            isScrollTop: false,
        },
        country: {
            value: '',
            isScrollTop: false,
        },
        living_city: {
            value: '',
            isScrollTop: false,
        },
        documents: {
            value: '',
            isScrollTop: false,
        },
        mobile_number: {
            value: '',
            isScrollTop: false,
        },
        email: {
            value: '',
            isScrollTop: false,
        },
        wechat_id: {
            value: '',
            isScrollTop: false,
        },
        social_media_accounts: {
            value: '',
            isScrollTop: false,
        },
        major: {
            value: '',
            isScrollTop: false,
        },
        work_experience: {
            value: '',
            isScrollTop: false,
        },
        self_introduction: {
            value: '',
            isScrollTop: false,
        },
        optional: {
            value: '',
            isScrollTop: false,
        },
        img: {
            value: '',
            isScrollTop: false,
        },
        video1: {
            value: '',
            isScrollTop: false,
        },
    });

    // 校验表单
    const checkFormDataHandle = () => {
        const dataOrder = [
            'name',
            'gender',
            'age',
            'education_level',
            'career',
            'language',
            'country',
            'living_city',
            'documents',
            'mobile_number',
            'email',
            'wechat_id',
            'social_media_accounts',
            'major',
            'work_experience',
            'self_introduction',
            'img1',
            'img2',
            'img3',
            'video1',
            'optional',
        ];
        const warningTextListNew = warningTextList;
        const name = formData['name'];
        const gender = formData['gender'];
        const age = formData['age'];
        const education_level = formData['education_level'];
        const career = formData['career'];
        const language = formData['language'];
        const country = formData['country'];
        const living_city = formData['living_city'];
        const documents = formData['documents'];
        const mobile_number = formData['mobile_number'];
        const email = formData['email'];
        const wechat_id = formData['wechat_id'];
        const social_media_accounts = formData['social_media_accounts'];
        const major = formData['major'];
        const work_experience = formData['work_experience'];
        const self_introduction = formData['self_introduction'];
        const img1 = formData['img1'];
        const img2 = formData['img2'];
        const img3 = formData['img3'];
        const video1 = formData['video1'];
        const optional = formData['optional'];

        // console.log(languages, 'languages')

        // 姓名
        if (name === '') {
            warningTextListNew['name']['value'] = area[languages].name.waring1;
        } else if (getStringLenth(name) > 100) {
            warningTextListNew['name']['value'] = area[languages].name.waring2;
        } else {
            warningTextListNew['name']['value'] = '';
        }
        // 性别
        if (gender === '') {
            warningTextListNew['gender']['value'] = area[languages].gender.waring1;
        } else {
            warningTextListNew['gender']['value'] = '';
        }
        // 年龄
        if (age === '') {
            warningTextListNew['age']['value'] = area[languages].age.waring1;
        } else if (age !== '' && getStringLenth(age) > 2) {
            warningTextListNew['age']['value'] = area[languages].age.waring2;
        } else if (age !== '' && !Number(age) && Number(age).toString().length !== getStringLenth(age)) {
            warningTextListNew['age']['value'] = area[languages].age.waring3;
        } else {
            warningTextListNew['age']['value'] = '';
        }

        // 教育程度
        if (education_level === '') {
            warningTextListNew['education_level']['value'] = area[languages].education_level.waring1;
        } else if (getStringLenth(education_level) > 100) {
            warningTextListNew['education_level']['value'] = area[languages].education_level.waring2;
        } else {
            warningTextListNew['education_level']['value'] = '';
        }

        // 现职
        if (getStringLenth(career) > 100) {
            warningTextListNew['career']['value'] = area[languages].career.waring2;
        } else {
            warningTextListNew['career']['value'] = '';
        }

        // 语言能力
        if (language === '') {
            warningTextListNew['language']['value'] = area[languages].language.waring1;
        } else if (getStringLenth(language) > 100) {
            warningTextListNew['language']['value'] = area[languages].language.waring2;
        } else {
            warningTextListNew['language']['value'] = '';
        }

        // 国家和地区
        if (country === '') {
            warningTextListNew['country']['value'] = area[languages].country.waring1;
        } else if (getStringLenth(country) > 100) {
            warningTextListNew['country']['value'] = area[languages].country.waring2;
        } else {
            warningTextListNew['country']['value'] = '';
        }

        // 目前所在城市
        if (living_city === '') {
            warningTextListNew['living_city']['value'] = area[languages].living_city.waring1;
        } else if (getStringLenth(living_city) > 100) {
            warningTextListNew['living_city']['value'] = area[languages].living_city.waring2;
        } else {
            warningTextListNew['living_city']['value'] = '';
        }

        // 目前所在城市
        if (documents === '') {
            warningTextListNew['documents']['value'] = area[languages].documents.waring1;
        } else if (getStringLenth(documents) > 100) {
            warningTextListNew['documents']['value'] = area[languages].documents.waring2;
        } else {
            warningTextListNew['documents']['value'] = '';
        }

        // 手机号
        if (mobile_number === '') {
            warningTextListNew['mobile_number']['value'] = area[languages].mobile_number.waring1;
        } else if (getStringLenth(mobile_number) > 100) {
            warningTextListNew['mobile_number']['value'] = area[languages].mobile_number.waring2;
        } else {
            warningTextListNew['mobile_number']['value'] = '';
        }

        // 邮箱
        if (email === '') {
            warningTextListNew['email']['value'] = area[languages].email.waring1;
        } else if (getStringLenth(email) > 100) {
            warningTextListNew['email']['value'] = area[languages].email.waring2;
        } else {
            warningTextListNew['email']['value'] = '';
        }

        // 微信
        if (getStringLenth(wechat_id) > 100) {
            warningTextListNew['wechat_id']['value'] = area[languages].wechat_id.waring2;
        } else {
            warningTextListNew['wechat_id']['value'] = '';
        }

        // 社交账号
        if (getStringLenth(social_media_accounts) > 100) {
            warningTextListNew['social_media_accounts']['value'] = area[languages].social_media_accounts.waring2;
        } else {
            warningTextListNew['social_media_accounts']['value'] = '';
        }

        // 最高学历
        if (major === '') {
            warningTextListNew['major']['value'] = area[languages].major.waring1;
        } else if (getStringLenth(major) > 100) {
            warningTextListNew['major']['value'] = area[languages].major.waring2;
        } else {
            warningTextListNew['major']['value'] = '';
        }

        // 工作经验
        if (getStringLenth(work_experience) > 300) {
            warningTextListNew['work_experience']['value'] = area[languages].work_experience.waring2;
        } else {
            warningTextListNew['work_experience']['value'] = '';
        }

        // 自我介绍
        if (self_introduction === '') {
            warningTextListNew['self_introduction']['value'] = area[languages].self_introduction.waring1;
        } else if (getStringLenth(self_introduction) > 40) {
            warningTextListNew['self_introduction']['value'] = area[languages].self_introduction.waring2;
        } else {
            warningTextListNew['self_introduction']['value'] = '';
        }

        // 选填输入框
        if (getStringLenth(optional) > 100) {
            warningTextListNew['optional']['value'] = area[languages].optional.waring1;
        } else {
            warningTextListNew['optional']['value'] = '';
        }

        // 照片
        if (img1 === '' || img2 === '' || img3 === '') {
            warningTextListNew['img']['value'] = area[languages].photo.waring3;
        } else {
            warningTextListNew['img']['value'] = '';
        }

        // 自我介绍视频
        if (video1 === '') {
            warningTextListNew['video1']['value'] = area[languages].video1.waring2;
        } else {
            warningTextListNew['video1']['value'] = '';
        }

        let flag = true;

        for (const key in warningTextListNew) {
            warningTextListNew[key]['isScrollTop'] = false;
        }

        for (let i = 0; i < dataOrder.length; i++) {
            if (warningTextList?.[dataOrder[i]]?.['value']) {
                warningTextListNew[dataOrder[i]]['isScrollTop'] = true;
                flag = false;
                break;
            } else {
                flag = true;
            }
        }

        if (!flag) {
            checkRequiredSucess = true;
        } else {
            checkRequiredSucess = false;
        }
        const stringifyData = JSON.stringify(warningTextListNew);
        const parseData = JSON.parse(stringifyData);

        setWarningTextList((data) => {
            return {
                ...data,
                ...parseData,
            };
        });
    };

    const setFormDataHandle = (key, value) => {
        const obj = {};

        obj[key] = value;
        setFormData((data) => {
            return {
                ...data,
                ...obj,
            };
        });
    };

    const understandHandle = (value) => {
        setUnderstand(value);
    };

    const confirmDataHandle = (value) => {
        if (value?.isClickOk === true) {
            setIsShowLoading(true);
        }

        setConfirmData(value);
    };

    // 校验表单所有操作
    const checkFormMenuHandle = () => {
        checkFormDataHandle();
        let isSubmitSucess = true;

        if (checkRequiredSucess) {
            isSubmitSucess = false;
            setIsClickSubmit(false);

            return false;
        }

        // 验证是否勾选知晓信息
        if (!understand) {
            Toast.show({
                content: area[languages].api.waring2,
                maskClickable: false,
            });
            isSubmitSucess = false;
            setIsClickSubmit(false);

            return false;
        }

        // 验证是否点击确认提交
        if (!confirmData.isClickOk) {
            confirmDataHandle({
                isClickOk: false,
                isCheck: false,
                isClosePopup: false,
            });

            return false;
        }

        return isSubmitSucess;
    };

    const submitFailHandle = () => {
        setIsShowLoading(false);
        confirmDataHandle({
            isClickOk: false,
            isCheck: false,
            isClosePopup: true,
        });
    };

    const submitHandle = async () => {
        // 数据提交
        if (checkFormMenuHandle()) {
            setIsShowLoading(true);

            // console.log(formData, 'formData');

            // return false;

            try {
                const submitResult = updateId ? await updateFormHandleArea2025(formData, updateId) : await submitFormHandleArea2025(formData);

                if (submitResult?.data?.data && submitResult?.data?.code === 0) {
                    setHasSucessPopup(true);
                    setlocal('area_id', submitResult?.data?.data?.data?._id);
                } else {
                    Toast.show({
                        content: area[languages].api.waring1,
                        maskClickable: false,
                    });
                    submitFailHandle();
                }
            } catch (e) {
                Toast.show({
                    content: area[languages].api.waring1,
                    maskClickable: false,
                });
                submitFailHandle();
            }
            setIsShowLoading(false);
        } else {
            submitFailHandle();
        }
    };

    // 初始化更新表单
    const getHostHandle = async () => {
        setIsShowLoading(true);
        try {
            const hostData = await getHostHandleArea2025(updateId);

            if (hostData?.data?.data) {
                const { img1_url, img2_url, img3_url, ...filterHostData } = hostData.data.data;

                setFormData({
                    ...filterHostData,
                });
                setlocal('areaimg1FormBase64Url', img1_url);
                setlocal('areaimg2FormBase64Url', img2_url);
                setlocal('areaimg3FormBase64Url', img3_url);
                setUpdateSuccess(true);
                setIsShowLoading(false);
            } else {
                setIsShowLoading(false);
            }
        } catch (e) {
            setIsShowLoading(false);
        }
    };

    // 点击模块框确认
    useEffect(() => {
        if (confirmData.isClickOk) {
            submitHandle();
        } else {
            setIsClickSubmit(false);
        }
    }, [confirmData]);

    // 点击提交确认
    useEffect(() => {
        if (isClickSubmit) {
            checkFormMenuHandle();
        }
    }, [isClickSubmit]);

    // 数据本地存储
    const saveFormDataHandle = () => {
        setlocal('areaformData', formData);
        Toast.show({
            content: area[languages].save.title,
            maskClickable: false,
        });
    };

    // 数据初始化
    useEffect(() => {
        const formData = getlocal('areaformData');

        // 更新数据初始化
        if (updateId) {
            getHostHandle();

            return false;
        }

        // 储存数据初始化
        if (formData) {
            setFormData({
                ...formData,
            });
        }
    }, []);

    const setLanguagesHandle = (value) => {
        setLanguages(value);
        setlocal('arealanguages', value);
    };

    useEffect(() => {
        let isWaring = false;

        // warningTextList对象key中的值value是否为空
        Object.keys(warningTextList).forEach((key) => {
            if (warningTextList[key].value && !isWaring) {
                isWaring = true;
            }
        });

        if (isWaring) {
            checkFormDataHandle();
        }

        document.title = area[languages].banner.title;
    }, [languages]);

    return (
        <div className={styles.layout}>
            <Banner languages={languages} setLanguagesHandle={setLanguagesHandle} />
            <Required languages={languages} formData={formData} setFormDataHandle={setFormDataHandle} warningTextList={warningTextList} updateSuccess={updateSuccess} />
            <Media languages={languages} formData={formData} setFormDataHandle={setFormDataHandle} warningTextList={warningTextList} updateId={updateId} updateSuccess={updateSuccess} />
            <Needlessly languages={languages} formData={formData} setFormDataHandle={setFormDataHandle} warningTextList={warningTextList} updateSuccess={updateSuccess} />
            <FormInfo languages={languages} understand={understand} understandHandle={understandHandle} />
            <FormSubmit languages={languages} clickSubmitHandle={setIsClickSubmit} saveFormDataHandle={saveFormDataHandle} />
            <Confirm languages={languages} confirmData={confirmData} confirmDataHandle={confirmDataHandle} updateId={updateId} />
            {hasSucessPopup && <Success languages={languages} updateId={updateId} />}
            {isShowLoading && (
                <div className={styles.loadingBox}>
                    <SpinLoading color="#CE6400" />
                </div>
            )}
            <SecondShare languages={languages} />
        </div>
    );
};

export default errorBoundary(Layout);
